import { useEffect } from "react";
import { useCmsContent } from "./use-cms-content";

/**
 * Dynamically updates the browser tab favicon and title
 * based on CMS settings (favicon_url and page_title).
 */
export const useFaviconTitle = () => {
  const { content, loading } = useCmsContent();

  useEffect(() => {
    if (loading) return;

    // Update page title
    if (content.page_title) {
      document.title = content.page_title;
    }

    // Update favicon
    if (content.favicon_url) {
      const link: HTMLLinkElement =
        document.querySelector("link[rel='icon']") ||
        document.createElement("link");
      link.rel = "icon";
      link.href = content.favicon_url;
      link.type = "image/png";
      if (!link.parentNode) {
        document.head.appendChild(link);
      }

      // Also update apple-touch-icon
      const appleLink: HTMLLinkElement | null =
        document.querySelector("link[rel='apple-touch-icon']");
      if (appleLink) {
        appleLink.href = content.favicon_url;
      }
    }
  }, [content, loading]);
};
